
import { BrowserRouter, Routes, Route } from "react-router-dom"; 
import Home from './Farrukhabad/Home'
import Events from './Farrukhabad/Events'
import Gallery from './Farrukhabad/Gallery'
import SubGallery from './Farrukhabad/SubGallery'
import ChairmanMessage from'./Farrukhabad/ChairmanMessage'
import ChairpersonMessage from'./Farrukhabad/ChairpersonMessage'
import AcademicHeadMessage from'./Farrukhabad/AcademicHeadMessage'
import PrincipalMessage from'./Farrukhabad/PrincipalMessage'
import SafetySecurity from'./Farrukhabad/SafetySecurity'
import Infrastructure from'./Farrukhabad/Infrastructure'
import ExtraCurricularActivity from'./Farrukhabad/ExtraCurricularActivity'
import Sports from'./Farrukhabad/Sports'
import LifeatGis from'./Farrukhabad/LifeatGis'
import Vision from'./Farrukhabad/Vision'
import Mission from'./Farrukhabad/Mission' 
import Career from'./Farrukhabad/Career' 
import Admission from'./Farrukhabad/Admission' 
import News from './Farrukhabad/News' 
import Tc from './Farrukhabad/Tc'
import ErpSoftware from './Farrukhabad/ErpSoftware'
import Main from "./Farrukhabad/Main"; 
import NkrChairmanMessage from'./nekhpur/ChairmanMessage'
import NkrChairpersonMessage from'./nekhpur/ChairpersonMessage'
import NkrAcademicHeadMessage from'./nekhpur/AcademicHeadMessage'
import NkrPrincipalMessage from'./nekhpur/PrincipalMessage'
import NkrSafetySecurity from'./nekhpur/SafetySecurity'
import NkrInfrastructure from'./nekhpur/Infrastructure'
import NkrExtraCurricularActivity from'./nekhpur/ExtraCurricularActivity'
import NkrSports from'./nekhpur/Sports'
import NkrLifeatGis from'./nekhpur/LifeatGis'
import NkrVision from'./nekhpur/Vision'
import NkrMission from'./nekhpur/Mission'
import NkrHome from './nekhpur/Home'
import NkrEvents from './nekhpur/Events'
import NkrGallery from './nekhpur/Gallery'
import NkrSubGallery from './nekhpur/SubGallery'
import NkrNews from './nekhpur/News' 
import NkrCareer from './nekhpur/Career' 
import NkrAdmission from './nekhpur/Admission'
import NkrTc from './nekhpur/Tc'
import NkrErpSoftware from './nekhpur/ErpSoftware'
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/HomeFr" element={<Home />} /> 
          <Route path="/Events" element={<Events />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/SubGallery" element={<SubGallery />} />
          <Route path="/News" element={<News />} /> 
          <Route path="/Tc" element={<Tc />} />
          <Route path="/ErpSoftware" element={<ErpSoftware />} />
          <Route path="/ChairmanMessage" element={<ChairmanMessage />} />
          <Route path="/ChairpersonMessage" element={<ChairpersonMessage />} />
          <Route path="/AcademicHeadMessage" element={<AcademicHeadMessage />} /> 
           <Route path="/PrincipalMessage" element={<PrincipalMessage />} /> 
          <Route path="/LifeatGis" element={<LifeatGis />} /> 
          <Route path="/SafetySecurity" element={<SafetySecurity />} /> 
          <Route path="/Infrastructure" element={<Infrastructure />} /> 
          <Route path="/ExtraCurricularActivity" element={<ExtraCurricularActivity />} /> 
          <Route path="/Sports" element={<Sports />} /> 
          <Route path="/Vision" element={<Vision />} />
          <Route path="/Mission" element={<Mission />} />
           <Route path="/Career" element={<Career />} />
            <Route path="/Admission" element={<Admission />} />
          <Route path="/nekhpur/ChairmanMessage" element={<NkrChairmanMessage />} />
          <Route path="/nekhpur/ChairpersonMessage" element={<NkrChairpersonMessage />} />
           <Route path="/nekhpur/AcademicHeadMessage" element={<NkrAcademicHeadMessage />} /> 
           <Route path="/nekhpur/PrincipalMessage" element={<NkrPrincipalMessage />} /> 
           <Route path="/nekhpur/LifeatGis" element={<NkrLifeatGis />} /> 
           <Route path="/nekhpur/SafetySecurity" element={<NkrSafetySecurity />} /> 
           <Route path="/nekhpur/Infrastructure" element={<NkrInfrastructure />} /> 
            <Route path="/nekhpur/ExtraCurricularActivity" element={<NkrExtraCurricularActivity />} /> 
            <Route path="/nekhpur/Sports" element={<NkrSports />} /> 
           <Route path="/nekhpur/Vision" element={<NkrVision />} />
           <Route path="/nekhpur/Mission" element={<NkrMission />} />
          <Route path="/Home" element={<NkrHome />} />
          <Route path="/nekhpur/Events" element={<NkrEvents />} />
          <Route path="/nekhpur/Gallery" element={<NkrGallery />} />
          <Route path="/nekhpur/SubGallery" element={<NkrSubGallery />} />
          <Route path="/nekhpur/News" element={<NkrNews />} /> 
          <Route path="/nekhpur/Career" element={<NkrCareer />} /> 
          <Route path="/nekhpur/Admission" element={<NkrAdmission />} /> 
          <Route path="/nekhpur/Tc" element={<NkrTc />} />
          <Route path="/nekhpur/ErpSoftware" element={<NkrErpSoftware />} />
          <Route path="/" element={<Main />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App;
